define('tdsearch', ['jquery', 'wabreakpoint'], function ($, wabreakpoint) {

  var tdsearch = {
    headerSearch: $('.header__search'),
    headerSearchBtn: $('.js_search'),
    openSearchField: function openSearchField() {
      if (wabreakpoint !== 'large') {
        if (!this.headerSearch.is(':visible')) {
          this.headerSearchBtn.trigger('click');
        }
      }
    },
    init: function init() {
      this.openSearchField();
    }
  };

  return tdsearch;
});

